import axios from "axios";

const getPersonas = () => {
  return axios.get(`/api/aipersonas`);
};

const createPersona = (formData) => {
  return axios.post(`/api/aipersonas`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getProfiles = () => {
  return axios.get(`/api/audio/voices`);
};

const updatePersona = (id, formData) => {
  return axios.put(`/api/aipersonas/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deletePersona = (id) => {
  return axios.delete(`/api/aipersonas/${id}`);
};

const getPersona = (id) => {
  return axios.get(`/api/aipersonas/${id}`);
};

const personaApi = {
  getPersonas,
  getPersona,
  createPersona,
  getProfiles,
  updatePersona,
  deletePersona,
};

export default personaApi;
